module.exports = __webpack_public_path__ + "img/IMG_8970.cdb700d2.jpg";